import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, InputNumber, Icon, Button, message, Spin, Checkbox, Radio } from 'antd';
import DataService from '../../lib/DataService';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
import SharedTools from '../../lib/SharedTools';
import Utils from "./ClockUtils";

const { TextArea } = Input;

export default class CreateNotificationsComponent extends React.Component {
  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: props.currentRole,
      schoolId: props.schoolId,
      visibility: "请选择班级...",
      title: "",
      content: "",
      uploadedFiles: [],
      uploadingFiles: [],
      classes: [],
      confirmedVisiblity: [],
      classesModalVisible: false,
      studentsModalVisible: false,
      spinning: true,
      allClassesChecked: false,
      allClassesCheckedConfirmed: false,

      frequencyArr: [
        { label: '周一', value: 1, selected: true },
        { label: '周二', value: 2, selected: true },
        { label: '周三', value: 3, selected: true },
        { label: '周四', value: 4, selected: true },
        { label: '周五', value: 5, selected: true },
        { label: '周六', value: 6, selected: true },
        { label: '周日', value: 0, selected: true },
      ],
      supplement: true,
      day: 31,

      students: [],
      selectedStudents: [],
      originStudents: [],

      fileType: 'photo'
    };
    // bind this
    this.onTitleChange = this.onTitleChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleNotificationPublish = this.handleNotificationPublish.bind(this);
    this.onAllClassesChecked = this.onAllClassesChecked.bind(this);
    this.onClassChecked = this.onClassChecked.bind(this);
    this.handleVisibilityOk = this.handleVisibilityOk.bind(this);
    this.handleStudentsOk = this.handleStudentsOk.bind(this);
    this.handleVisibilityCancel = this.handleVisibilityCancel.bind(this);
    this.handleStudentsCancel = this.handleStudentsCancel.bind(this);
    this.showClassesModal = this.showClassesModal.bind(this);
    this.showStudentsModal = this.showStudentsModal.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileUploadError = this.onFileUploadError.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
  }

  componentDidMount() {
    DataService.getClassList({ school_id: this.state.schoolId }).then(response => {
      // classes: grouped by grade number
      let classes = [1, 2, 3, 4, 5].map(gradeNumber => {
        return ({
          checked: true,
          gradeNumber: gradeNumber,
          classes: response.filter(c => c.grade_number == gradeNumber)
        });
      }).filter(g => g.classes.length > 0).sort((g1, g2) => g1.gradeNumber - g2.gradeNumber)

      classes.forEach(g => {
        g.visibilityClassIds = g.classes.map(c => c.id);
        g.gradeName = g.classes[0].grade_name;
        g.is_graduated = g.classes[0].is_graduated;
      })

      let grades = classes.filter((c) => !c.is_graduated);

      this.setState({
        classes: grades,
        confirmedVisiblity: classes.map(g => { return ({ checked: g.checked, visibilityClassIds: g.visibilityClassIds }) }),
        allClassesChecked: true,
        allClassesCheckedConfirmed: true,
        visibility: "全校",
        spinning: false
      });
    }, error => {
      console.log(error);
      message.error("加载失败，请稍后重试");
      this.setState({
        spinning: false
      });
    })

    this.getStudents();

  }

  getStudents() {
    if (this.state.currentRole.associatName == "classRecord") {
      DataService.getStudents(this.state.currentRole.associatObj.id).then(response => {
        this.setState({
          students: response,
          selectedStudents: response.map(s => s.id),
          originStudents: response.map(s => s.id),
        })
      }, error => {
        console.log(error);
        message.error("加载失败，请稍后重试");
        this.setState({
          spinning: false
        });
      })
    }
  }

  onTitleChange(e) {
    this.setState({
      title: e.currentTarget.value
    });
  }

  onContentChange(e) {
    this.setState({
      content: e.currentTarget.value
    });
  }

  handleNotificationPublish() {
    if (!this.state.title || this.state.title.length <= 0) {
      message.error('打卡主题不能为空！');
      return;
    }

    if (!this.state.content || this.state.content.length <= 0) {
      message.error('打卡介绍不能为空！');
      return;
    }

    if (this.state.uploadedFiles.length <= 0) {
      message.error('请上传图片！');
      return;
    }

    if (this.state.uploading) {
      message.error('请等待图片上传结束！');
      return;
    }

    let student_ids = [], class_record_ids = [], frequency_info = [], files = [];
    if (this.state.currentRole.associatName == "classRecord") {
      student_ids = this.state.selectedStudents;
      class_record_ids = [this.state.currentRole.associatObj.id]
    } else {
      class_record_ids = this.state.confirmedVisiblity.map(g => g.visibilityClassIds).reduce((a, b) => a.concat(b));
    }

    frequency_info = this.state.frequencyArr.filter(item => item.selected).map(item => item.value);
    files = this.state.uploadedFiles.map(item => {
      return {
        url: item.remote_url,
        size: item.size,
        h: item.info.h,
        w: item.info.w,
        type: this.state.fileType
      }
    })

    if (frequency_info.length <= 0) {
      message.error('请选择打卡频率！');
      return;
    }

    if (student_ids <= 0 && class_record_ids <= 0) {
      message.error('请选择可见范围');
      return;
    }

    let data = {
      title: this.state.title,
      description: this.state.content,
      files: JSON.stringify(files),
      attendance_count: this.state.day,
      frequency_info,
      can_supplement: this.state.supplement,
      class_record_ids,
    }

    if (this.state.currentRole.associatName == "classRecord") {
      data.student_ids = student_ids;
    }


    this.setState({
      spinning: true
    });
    DataService.createDailyAttendanceTasks(data).then(response => {
      message.success("成功发布打卡任务！");
      this.state.classes.forEach(g => {
        g.checked = true,
          g.visibilityClassIds = g.classes.map(c => c.id);
      })
      this.setState({
        title: "",
        content: "",
        uploadedFiles: [],
        uploadingFiles: [],
        visibility: "全校",
        day: 31,
        frequencyArr: [
          { label: '周一', value: 1, selected: true },
          { label: '周二', value: 2, selected: true },
          { label: '周三', value: 3, selected: true },
          { label: '周四', value: 4, selected: true },
          { label: '周五', value: 5, selected: true },
          { label: '周六', value: 6, selected: true },
          { label: '周日', value: 0, selected: true },
        ],
        supplement: true,
        allClassesChecked: true,
        allClassesCheckedConfirmed: true,
        confirmedVisiblity: this.state.classes.map(g => { return ({ checked: g.checked, visibilityClassIds: g.visibilityClassIds }) }),
        spinning: false
      })
      this.getStudents();
    }, error => {
      console.log(error);
      message.error("发布通知失败，请稍后重试");
      this.setState({
        spinning: false
      })
    })
  }

  onAllClassesChecked() {
    if (this.state.allClassesChecked) {
      this.state.classes.forEach(g => {
        g.visibilityClassIds = [];
        g.checked = false;
      })
      this.setState({
        classes: this.state.classes,
        allClassesChecked: false
      })
    } else {
      this.state.classes.forEach(g => {
        g.visibilityClassIds = g.classes.map(c => c.id)
        g.checked = true;
      })
      this.setState({
        classes: this.state.classes,
        allClassesChecked: true
      })
    }
  }

  onClassChecked(gradeNumber, classId) {
    let grade = this.state.classes.find(c => c.gradeNumber == gradeNumber)
    if (!grade) {
      return;
    }

    if (classId) {
      let index = grade.visibilityClassIds.indexOf(classId);
      if (index >= 0) {
        grade.visibilityClassIds.splice(index, 1);
      } else {
        grade.visibilityClassIds.push(classId);
      }
    } else {
      if (grade.checked) {
        grade.visibilityClassIds = [];
      } else {
        grade.visibilityClassIds = grade.classes.map(c => c.id);
      }
    }

    grade.checked = grade.visibilityClassIds.length >= grade.classes.length;

    this.setState({
      classes: this.state.classes,
      allClassesChecked: this.state.classes.filter(g => g.checked).length == this.state.classes.length
    })
  }

  changeFrequency(index) {
    let { frequencyArr } = this.state;
    frequencyArr[index].selected = !frequencyArr[index].selected;
    this.setState({
      frequencyArr
    })
  }

  onDayChange(value) {
    this.setState({
      day: value
    })
  }

  handleVisibilityOk() {
    let confirmedVisiblity = this.state.classes.map(g => { return ({ checked: g.checked, visibilityClassIds: g.visibilityClassIds }) });

    let visibility = ""

    if (this.state.allClassesChecked) {
      visibility = "全校";
    } else {
      visibility = this.state.classes.filter(g => g.visibilityClassIds.length > 0).map(g => g.gradeName).join("、");
    }

    if (visibility == "") {
      visibility = "请选择班级...";
    }

    this.setState({
      visibility: visibility,
      classesModalVisible: false,
      classes: this.state.classes,
      confirmedVisiblity: confirmedVisiblity,
      allClassesCheckedConfirmed: this.state.allClassesChecked,
    })
  }

  handleVisibilityCancel() {
    this.state.classes.forEach((g, index) => {
      g.checked = this.state.confirmedVisiblity[index].checked;
      g.visibilityClassIds = this.state.confirmedVisiblity[index].visibilityClassIds;
    });
    this.setState({
      classesModalVisible: false,
      classes: this.state.classes,
      allClassesChecked: this.state.allClassesCheckedConfirmed,
    });
  }

  showClassesModal() {
    this.setState({
      classesModalVisible: true
    })
  }

  _checkCircleIcon(checked, onClick) {
    if (checked) {
      return (<Icon className={checked ? "checked" : ""} onClick={onClick} type="check-circle" />);
    } else {
      return (<Icon className={checked ? "checked" : ""} onClick={onClick} type="check-circle-o" />);
    }
  }

  _selectClassesModal() {
    return (
      <Modal wrapClassName="notifications-select-classes-modal" visible={this.state.classesModalVisible} onCancel={this.handleVisibilityCancel} maskClosable={false} footer={[
        <Button className="confirm-visibility-button" type="primary" key="confirm" onClick={this.handleVisibilityOk}>确认班级</Button>
      ]}>
        <div className="selected-classes-count">已选{this.state.classes.map(g => g.visibilityClassIds.length).reduce((a, b) => a + b, 0)}个班级</div>
        <div className={"all-classes-check-box" + (this.state.allClassesChecked ? " checked" : "")}>
          {this._checkCircleIcon(this.state.allClassesChecked, this.onAllClassesChecked)}
          <div className="all-classes-label">全校</div>
        </div>
        {this.state.classes.map(grade =>
          <div className="grade-classes-check-box" key={grade.gradeNumber} >
            {this._checkCircleIcon(grade.checked, this.onClassChecked.bind(this, grade.gradeNumber, undefined))}
            <div className="grade-name">{grade.gradeName}</div>
            <div className="grade-classes-container">
              {grade.classes.map(c => <div className={"class-name" + (grade.visibilityClassIds.indexOf(c.id) >= 0 ? " checked" : "")} key={c.id} onClick={this.onClassChecked.bind(this, grade.gradeNumber, c.id)}>{c.name}</div>)}
            </div>
          </div>
        )}
      </Modal>
    )
  }

  showStudentsModal() {
    this.setState({
      studentsModalVisible: true,
      originStudents: SharedTools.cloneObject(this.state.selectedStudents)
    })
  }

  selectedStudent(studentId) {
    let index = this.state.originStudents.indexOf(studentId);
    if (index >= 0) {
      this.state.originStudents.splice(index, 1);
    } else {
      this.state.originStudents.push(studentId)
    }

    this.setState({
      originStudents: this.state.originStudents,
    })
  }

  handleSelecteAllStudents() {
    if (this.state.originStudents.length >= this.state.students.length) {
      this.setState({
        originStudents: [],
      })
    } else {
      this.setState({
        originStudents: this.state.students.map(s => s.id),
      })
    }
  }

  handleStudentsCancel() {
    this.setState({
      studentsModalVisible: false
    })
  }

  handleStudentsOk() {
    if (this.state.originStudents.length <= 0) {
      message.info('请至少选择一名学生');
      return
    }
    this.setState({
      selectedStudents: SharedTools.cloneObject(this.state.originStudents),
      studentsModalVisible: false
    })
  }

  _selectStudentsModal() {
    return (
      <Modal wrapClassName="notifications-select-classes-modal" visible={this.state.studentsModalVisible} onCancel={this.handleStudentsCancel} maskClosable={false} footer={[
        <Button className="confirm-visibility-button" type="primary" key="confirm" onClick={this.handleStudentsOk}>确认（已选{this.state.originStudents.length}人）</Button>
      ]}>
        <div className="selected-classes-count">选择宝贝</div>
        <div className="export-reports">
          <Checkbox className='select-all-students' onChange={this.handleSelecteAllStudents.bind(this)} checked={this.state.originStudents.length >= this.state.students.length}>全选</Checkbox>
          <div className="export-report-students">
            {this.state.students.map((student, index) =>
              <div key={student.id} onClick={this.selectedStudent.bind(this, student.id)} className={"export-student" + (this.state.originStudents.indexOf(student.id) >= 0 ? " selected" : "")} >{student.full_name}</div>
            )}
          </div>
        </div>
      </Modal>
    )
  }

  changeFileType(e) {
    this.setState({
      fileType: e.target.value
    })

  }

  toolUpdateFilesList(type, newFilesList) {
    if (type == 'uploaded')
      this.setState({
        uploadedFiles: newFilesList
      });
    else if (type == 'uploading')
      this.setState({
        uploadingFiles: newFilesList
      });

    return true;
  }

  getAvailableQuotaForUploadingFiles() {
    return (this.state.fileType == 'photo' ? 9 : 1) - this.state.uploadedFiles.length - this.state.uploadingFiles.length;
  }

  onFileStartUpload(newFileKey) {
    // check quota limit
    if (this.getAvailableQuotaForUploadingFiles() <= 0)
      return false;
    // check file duplicated
    let exist1 = undefined != this.state.uploadedFiles.find((uploadedFile) => uploadedFile.key.split("#")[0] == newFileKey);
    let exist2 = undefined != this.state.uploadingFiles.find((uploadingFile) => uploadingFile.key == newFileKey);
    if (exist1 || exist2)
      return false;

    // update uploadingFiles
    let newFiles = SharedTools.cloneObject(this.state.uploadingFiles);
    newFiles.push(newFileKey);

    return this.toolUpdateFilesList('uploading', newFiles);
  }

  onFileUploadSuccess(newFileKey, fileName, fileSize, remoteUrl, info) {
    let newFiles = SharedTools.cloneObject(this.state.uploadedFiles);
    newFiles.push({
      key: newFileKey + "#" + Date.now(),
      name: fileName,
      size: fileSize,
      remote_url: remoteUrl,
      info: info
    });
    // set state: uploaded
    this.toolUpdateFilesList('uploaded', newFiles);

    // set state: uploading
    newFiles = this.state.uploadingFiles.filter((uploadingFileKey) => uploadingFileKey != newFileKey);
    this.toolUpdateFilesList('uploading', newFiles);
  }

  onFileUploadError(fileKey, fileObj, errorKey) {
    // let uploadedFiles = SharedTools.cloneObject(this.state.uploadedFiles), filesArray = this.state.filesArray;
    // let index = uploadedFiles.findIndex((file) => (!file.isUploaded && file.key == errorKey));
    // // 上传失败后避免重复上传
    // if (index < 0) {
    //   uploadedFiles.push({
    //     key: fileKey,
    //     isUploaded: false,
    //     fileName: fileObj.name
    //   });

    //   // 存入对象数组
    //   filesArray.push({
    //     key: fileKey,
    //     file: fileObj
    //   })
    //   this.setState({
    //     filesArray: filesArray
    //   })

    //   // set state: uploaded
    //   this.toolUpdateFilesList('uploaded', uploadedFiles);

    // }
    message.error('上传失败！')

    let newFiles = this.state.uploadingFiles.filter((uploadingFileKey) => uploadingFileKey != fileKey);
    // console.log(newFiles)
    this.toolUpdateFilesList('uploading', newFiles);
  }


  isAllUploadingFileFinished() {
    return this.state.uploadingFiles.length <= 0;
  }

  removeUploadedFile(e) {
    e.stopPropagation();
    let index = this.state.uploadedFiles.findIndex(f => f.key == e.currentTarget.dataset.filekey)
    if (index >= 0) {
      this.state.uploadedFiles.splice(index, 1);
      this.toolUpdateFilesList('uploaded', this.state.uploadedFiles);
    }
  }

  _uploadPhotos() {
    return (
      <div className="upload-photos-container">
        {this.state.uploadedFiles.map(file =>
          <div className="uploaded photo" key={file.key}>
            <img src={Utils.getSmallMedia(file.remote_url, this.state.fileType)} style={{width: '100px', height: '100px'}}/>
            <div className="file-remove" data-filekey={file.key} onClick={this.removeUploadedFile.bind(this)}><Icon type="close" /></div>
          </div>
        )}

        {this.state.uploadingFiles.map(file =>
          <div className="uploading photo" key={file.key}>
            <Spin wrapperClassName="uploading-spin">
              <div className="uploading-holder"></div>
            </Spin>
          </div>
        )}

        {this.getAvailableQuotaForUploadingFiles() > 0 && <div className="uploading-module-container">
          <ReactQiniuModule
            className="uploading-module"
            onSuccess={this.onFileUploadSuccess}
            onError={this.onFileUploadError}
            onStartPermit={this.onFileStartUpload}
            isAllFinish={this.isAllUploadingFileFinished}
            getUploadQuota={this.getAvailableQuotaForUploadingFiles}
            allowUploadFileTypes={this.state.fileType == 'photo' ? ReactQiniuModule.getFileCategories.IMAGES : ReactQiniuModule.getFileCategories.VIDEOS}
            allowUploadFileSize={10} >
            <div className="uploading-content"><div className="tip">+ 添加{this.state.fileType == 'photo' ? '照片' : '视频'}</div></div>
          </ReactQiniuModule>
        </div>}
      </div>
    )
  }

  render() {
    let { frequencyArr, supplement } = this.state;
    return (
      <div className="create-notification"><Spin spinning={this.state.spinning}>
        <div className="create-notification-area">
          <label className="notification-title-label">打卡主题</label>
          <Input className="notification-title" value={this.state.title} onChange={this.onTitleChange} placeholder="限制12个字" maxLength={12} />
          <TextArea className="notification-content" value={this.state.content} onChange={this.onContentChange} placeholder="输入打卡介绍" rows={10} />
          <Radio.Group value={this.state.fileType} style={{ marginTop: 16 }} onChange={(e) => this.changeFileType(e)} disabled={this.state.uploadedFiles.length > 0 || this.state.uploadingFiles.length > 0}>
            <Radio.Button value="photo">照片</Radio.Button>
            <Radio.Button value="video">视频</Radio.Button>
          </Radio.Group>
          {this._uploadPhotos()}
          <label className="notification-title-label">持续时间</label>
          <div style={{ margin: '5px 0' }}>
            <InputNumber value={this.state.day} onChange={(value) => this.onDayChange(value)} style={{ width: '80px', marginRight: '10px' }} min={1} max={100} />天
          </div>
          <label className="notification-title-label">打卡频率</label>
          <div className="frequency-container">
            {frequencyArr.map((item, index) => <div className={"frequency-item" + (item.selected ? " selected" : "")} key={index} onClick={() => this.changeFrequency(index)}>
              {item.selected ? <Icon type="check-circle" theme="filled" className="selected-icon" /> : ''}
              {item.label}
            </div>)}
          </div>
          <label className="notification-title-label">是否允许补卡</label>
          <div className="frequency-container">
            <div className={"frequency-item" + (supplement ? " selected" : "")} onClick={() => this.setState({ supplement: !supplement })}>
              {supplement ? <Icon type="check-circle" theme="filled" className="selected-icon" /> : ''}允许
            </div>
            <div className={"frequency-item" + (!supplement ? " selected" : "")} onClick={() => this.setState({ supplement: !supplement })}>
              {!supplement ? <Icon type="check-circle" theme="filled" className="selected-icon" /> : ''}不允许
            </div>
          </div>
          <div className="line"></div>
          {this.state.currentRole.associatName == "classRecord" && <div className="visibility-container">
            <span>打卡参与人员：</span>
            <Input className="visibility" value={this.state.selectedStudents.length >= this.state.students.length ? '全班' : '部分学生'} onClick={this.showStudentsModal} />
            {this.state.selectedStudents.length < this.state.students.length ? <span>已选{this.state.selectedStudents.length}名学生</span> : ''}
          </div>}
          {this.state.currentRole.associatName != "classRecord" && <div className="visibility-container">
            <span>打卡参与班级：</span>
            <Input className="visibility" value={this.state.visibility} onClick={this.showClassesModal} />
            <span>已选{this.state.confirmedVisiblity.map(g => g.visibilityClassIds.length).reduce((a, b) => a + b, 0)}个班级</span>
          </div>}
        </div>
        <Button className="publish-button" type="primary" onClick={this.handleNotificationPublish} disabled={this.state.currentRole && this.state.currentRole.associatObj.is_graduated}>发布</Button>
        {(this.state.currentRole && this.state.currentRole.associatObj.is_graduated) ? <div style={{ color: 'red', margin: '10px 0' }}>班级已毕业 无法发布打卡任务</div> : ''}
        {this.state.currentRole.associatName != "classRecord" && this._selectClassesModal()}
        {this.state.currentRole.associatName == "classRecord" && this._selectStudentsModal()}
      </Spin></div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/CreateTaskPage.jsx